import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { fireDayDone, eventsChanged, StreakChip } from './DayDoneCelebration';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const addDays = (iso, n) => { const d = new Date(`${iso}T12:00`); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
export async function toggleEventDone(e) {
  const url = `${API}/calendar/events/${e.completed ? 'uncomplete' : 'complete'}`;
  const { data } = await axios.post(url, { event_id: e.id, occurrence_date: e.date }, { withCredentials: true });
  eventsChanged();
  if (!e.completed && data.points_earned) toast.success(`✓ ${e.title} är klar! +${data.points_earned} poäng`);
  return !e.completed;
}

const WD = ['sön', 'mån', 'tis', 'ons', 'tor', 'fre', 'lör'];

export default function SyncedEvents({ from, to, title = 'Från kalendern', testid = 'synced-events', refreshKey = 0 }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/calendar/occurrences`, { params: { from_day: from, to_day: to }, withCredentials: true })
      .then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, [from, to, refreshKey]);
  const toggle = async (i) => {
    const e = items[i];
    const next = items.map((x, j) => (j === i ? { ...x, completed: !x.completed } : x));
    setItems(next);
    if (!e.completed && from === to && next.every((x) => x.completed)) fireDayDone();
    try { await toggleEventDone(e); } catch {
      setItems((cur) => cur.map((x, j) => (j === i ? { ...x, completed: e.completed } : x)));
      toast.error('Kunde inte spara');
    }
  };
  if (!items.length) return null;
  const multi = from !== to;
  return (
    <section className="mb-4 rounded-lg border-2 border-[#DED0F0] bg-[#FBF8FF] p-3" data-testid={testid}>
      <div className="flex flex-wrap items-center justify-between gap-2 mb-1.5">
        <div className="text-[10px] tracking-widest font-black text-[#7D6BA0] uppercase">📌 {title}</div>
        {from === to && <StreakChip testid={`${testid}-streak`} />}
      </div>
      <ul className="space-y-1">
        {items.map((e, i) => (
          <li key={`${e.id}-${e.date}-${i}`} className="flex items-center gap-2 text-xs text-[#4E4370]" data-testid={`${testid}-item-${i}`}>
            <button onClick={() => toggle(i)} aria-label={e.completed ? 'Ångra klar' : 'Markera som klar'}
              className={`w-4 h-4 flex-shrink-0 rounded border-2 flex items-center justify-center text-[10px] font-black transition-colors ${e.completed ? 'bg-[#C8B6FF] border-[#7D6BA0] text-white' : 'border-[#C8B6FF] bg-white hover:bg-[#F5EEFF]'}`}
              data-testid={`${testid}-check-${i}`}>{e.completed ? '✓' : ''}</button>
            {multi && <span className="w-14 flex-shrink-0 font-bold capitalize text-[#8B7BAA]">{WD[new Date(`${e.date}T12:00`).getDay()]} {Number(e.date.slice(8))}/{Number(e.date.slice(5, 7))}</span>}
            <span className="w-10 flex-shrink-0 font-bold text-[#7D6BA0]">{e.time || 'Heldag'}</span>
            <span className={`flex-1 ${e.completed ? 'line-through opacity-50' : ''}`}>{e.important ? '★ ' : ''}{e.title}</span>
            {e.in_paper && <span title="Med i dagstidningen" className="text-[11px]">📰</span>}
          </li>
        ))}
      </ul>
    </section>
  );
}
